import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalyticsOnce, trackPageView } from "./analytics";

/** Hook: Analytics-Tracker einmal initialisieren und bei jedem Route-Wechsel
 *  einen `page_view` senden. Wird in `App.js` innerhalb des Routers gemountet. */
export function useAnalytics(): void {
    const loc = useLocation();
    useEffect(() => {
        initAnalyticsOnce();
    }, []);
    useEffect(() => {
        // Admin-Routen NICHT tracken — nur öffentliche Seiten.
        if (loc.pathname.startsWith("/admin")) return;
        const path = loc.pathname + (loc.search || "");
        trackPageView(path);
    }, [loc.pathname, loc.search]);
}
